import { ReactElement, memo } from "react";
import styled from "styled-components";
import { theme } from "../../theme";
import { h } from "../../h";

export const ArrowDown = memo(
    ({ className }: { className?: string }): ReactElement => {
        return h(
            `svg`,
            {
                className,
                width: 13,
                height: 8,
                viewBox: "0 0 13 8",
            },
            h(`path`, {
                d:
                    "M1.08333 0L6.5 5.90857L11.9167 0L13 1.14285L6.5 8L0 1.14285L1.08333 0Z",
                fill: theme.colorAccent,
            }),
        );
    },
);

export const ArrowUp = styled(ArrowDown)`
    transform: rotate(180deg);
`;

export const ArrowLeft = styled(ArrowDown)`
    transform: rotate(90deg);
`;

export const ArrowRight = styled(ArrowDown)`
    transform: rotate(270deg);
`;
